define([
    "./nlgHealthCheckerModule",
    "text!./nlgHealthInfoDetailed.html",
], function (module, template) {
    "use strict";

    return module.directive("nlgHealthInfoDetailed", [function () {
        return {
            template: template,
            scope: {
                info: "<"
            }
        };
    }]);
});
